import React from "react";
import { get, orderBy, sumBy } from "lodash";
import { Box } from "rebass";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import { CollapseMui } from "../../../../components";
import { StyledTableRow } from "../edit";
import { ItemViewFields } from "./CurrencyField";
import { PromoType_B } from "../edit";
const ViewSpecialPriceItems = (props) => {
  const { child } = props;
  const PromoType = get(child, "promotion_type", "");
  const labelSP = PromoType === PromoType_B[3] ? PromoType_B[3] : "";
  const listPromo = get(child, "list", []);
  const totalQty = sumBy(listPromo, "qty");
  const newListPromo = orderBy(listPromo, "sort_order", "asc");
  return (
    <Box width={[1]}>
      <CollapseMui
        label={`Promotion ${get(child, "promotions.name", "")} ${labelSP}`}
        isLeft={true}
        style={{ backgroundColor: "rgba(231,231,231,0.8)" }}
        defaultExpand={true}
      >
        <TableContainer component={"div"}>
          <Table aria-label='customized table'>
            <TableBody>
              {newListPromo.length > 0 &&
                newListPromo.map((promo, indexPromo) => {
                  const myMoqList =
                    get(promo, "promotions.criteria.price.moqs", []) !== null
                      ? get(promo, "promotions.criteria.price.moqs", [])
                      : [];
                  const myPrice = get(promo, "price", 0);
                  const moqsSP = orderBy(myMoqList, "moq", "desc");
                  let specialPrice = myPrice;
                  if (moqsSP.length > 0) {
                    if (totalQty >= moqsSP[0].moq) {
                      specialPrice = moqsSP[0].price;
                    } else {
                      if (moqsSP.length > 1) {
                        if (totalQty >= moqsSP[1].moq) {
                          specialPrice = moqsSP[1].price;
                        } else {
                          if (moqsSP.length > 2) {
                            if (totalQty >= moqsSP[1].moq) {
                              specialPrice = moqsSP[1].price;
                            } else if (totalQty >= moqsSP[2].moq) {
                              specialPrice = moqsSP[2].price;
                            }
                          }
                        }
                      }
                    }
                  }
                  promo["discounted_price"] = specialPrice;
                  const subtotal = specialPrice * get(promo, "qty", 0);
                  const isCRDG =
                    get(promo, "cr", false) === true ||
                    get(promo, "dg", false) === true
                      ? { backgroundColor: "#FF0000", color: "#FFFFFF" }
                      : {};
                  const isCRDGCOLOR =
                    get(promo, "cr", false) === true ||
                    get(promo, "dg", false) === true
                      ? { color: "#FFFFFF" }
                      : { color: "rgba(0, 0, 0, 0.87)" };
                  return (
                    <StyledTableRow key={indexPromo} style={{ isCRDG }}>
                      <ItemViewFields
                        promo={promo}
                        subtotal={subtotal}
                        isCRDGCOLOR={isCRDGCOLOR}
                      />
                    </StyledTableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </CollapseMui>
    </Box>
  );
};

export default ViewSpecialPriceItems;
